import Vue from 'vue'

Vue.prototype.$http = window.axios

export default new Vue({
    data: {
        listItems: ['Assurance', 'Direct tax Advisory', 'Indirect tax Advisory']
    },
    watch: {
      
    },
    computed:{
       
    },
    methods: {
       
    },

    
})
